import React, { useState, useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../utils/translations';
import '../../styles/Navbar.css';

// Importar iconos
import { FaSun, FaMoon, FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const { theme, toggleTheme } = useTheme();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { language, toggleLanguage } = useLanguage();
  
  // Acceso rápido a las traducciones del navbar
  const t = translations[language].navbar;

  // Detectar scroll para cambiar estilos de la barra de navegación
  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Manejar apertura/cierre del menú móvil
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${theme}`}>
      <div className="navbar-container">
        <a href="#about" className="navbar-logo">
          <span>{t.logo.prefix}</span>{t.logo.suffix}
        </a>

        {/* Botón de menú para móviles */}
        <div className="mobile-menu-icon" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </div>

        {/* Menú de navegación */}
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <a href="#hero" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              {t.links.home}
            </a>
          </li>
          <li className="nav-item">
            <a href="#about" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              {t.links.about}
            </a>
          </li>
          <li className="nav-item">
            <a href="#experience" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              {t.links.experience}
            </a>
          </li>
          <li className="nav-item">
            <a href="#projects" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              {t.links.projects}
            </a>
          </li>
          <li className="nav-item">
            <a href="#certificates" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              {t.links.certifications}
            </a>
          </li>
          <li className="nav-item">
            <a href="#skills" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              {t.links.skills}
            </a>
          </li>
          <li className="nav-item">
            <a href="#contact" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              {t.links.contact}
            </a>
          </li>
          <li className="nav-item theme-toggle" onClick={toggleTheme}>
            {theme === 'light' ? <FaMoon /> : <FaSun />}
          </li>
          <li className="nav-item language-toggle" onClick={toggleLanguage}>
            <span>{language.toUpperCase()}</span>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;